<template>
  <div id="app-cont" class="flex flex-center flex-column dark">
    <div class="nav-bar-cont flex ">
      <div class="nav-title-bar flex align-center">
        <div class="nav-title">{{ title }}</div>
        <div class="nav-btn">
          <ButtonCompVue
            v-if="authenticated"
            label="Logout"
            size="btn-small"
            type="outline"
            @btn-click="onClickLogout">
          </ButtonCompVue>
        </div>
      </div>
    </div>

    <div v-if="authenticated" class="menu-cont">
      <LeftMenu 
        :menuItems="links" />
    </div>

    <div v-if="authenticated" class="main-cont">
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <div v-else class="main-cont no-auth">
      <LoadingWidget
        type="bar"
        ref="loading"
        :class="{ hide: pageLoaded }"
      ></LoadingWidget>
      <LoginCompVue
        :class="{ hide: !pageLoaded }"
        :authCheck="authenticated"
        @login:success="onLoginSuccess" />
    </div>
  </div>
</template>

<script>
import ButtonCompVue from '@Common/components/ButtonCompVue'
import LoginCompVue from '@Common/components/LoginCompVue'
import LoadingWidget from '@Common/elements/LoadingWidget'
import { checkAuthentication } from '@Common/components/composables/auth'
import { useCoreUserStore } from '@Common/stores/CoreStore'

import LeftMenu from '@/components/LeftMenu'

export default {
  name: 'App',

  setup() {
    const coreUser = useCoreUserStore()

    return {
      coreUser,
    }
  },

  data() {
    return {
      title: 'Personal Finance Tracker',
      authenticated: false,
      pageLoaded: false,
      today: new Date(),
    };
  },

  computed: {
    links() {
      const year = this.today.getFullYear()
      const month = this.today.getMonth() + 1
      return [
        { name: 'Home', href: 'index' },
        { name: 'Calendar', href: 'monthly' , params: { year, month }},
        { name: 'Purchases', href: 'purchases' },
        //{ name: 'Businesses', href: 'businesses' },
        //{ name: 'Categories', href: 'categories' },
      ]
    },
  },

  methods: {
    onClickLogout() {
      this.coreUser.logout().then(() => {
        this.authenticated = false
      })
    },

    onLoginSuccess() {
      this.pageLoaded = true
      this.authenticated = true
    },
  },

  created() {},

  mounted() {
    checkAuthentication().then(r => {
      this.authenticated = r
      this.pageLoaded = true
    }, () => {
      this.pageLoaded = true
    })
  },

  components: {
    ButtonCompVue,
    LeftMenu,
    LoginCompVue,
    LoadingWidget,
  },
};
</script>

<style lang="scss">
.login-widget-cont {
  width: 400px;
  margin: 0 auto;
}
</style>
